import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Tab,
  Box,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { BiMinusCircle } from "react-icons/bi";
import { useMutation, useQuery } from "@apollo/client";

//src

import ViewRecieve from "./ReviewReq/ViewRecieve";
import ViewPurchase from "./ReviewReq/ViewPurchase";
import ViewReqPurchase from "./ReviewReq/ViewReqPurchase";
import CheckApprove from "./ReviewReq/CheckApprove";
import "../../Style/dialogstyle.scss";
import ListPurchase from "./ListPurchase";
// import {  GET_RECIEVE_PUR_BY_PUR_ID } from "../../../Schema/Reqpurchase"
import { SelectWarehouse } from "../Include/DynamicSelect";

export default function CheckReviewPurchase({
  open,
  handleClose,
  setRefetch,
  editData,
  checkReqPurchaseData,
  getPurchaseByCheckReqId,
}) {
  //tab
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">ពិនិត្យទទួល</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={editData?.voidBy === null ? 12 : 6}>
            <Typography className="dialog-title-view">សម្ភារៈ</Typography>
          </Grid>
          {/* {editData?.voidBy !== null ? (
            <Grid item xs={1}>
            </Grid>
          ) : null} */}
          {editData?.voidBy !== null ? (
            <Grid item xs={3}>
              <Typography className="dialog-title-void">បានធ្វើមោឃៈ</Typography>
            </Grid>
          ) : null}

          <Grid item xs={editData?.voidBy === null ? 12 : 6}>
            <Stack direction="row" spacing={2}>
              <Stack direction="column" spacing={2}>
                <Typography className="field-title">អ្នកផ្គត់ផ្គង់</Typography>
                <Typography className="field-title">ឃ្លាំងទំនិញ</Typography>
              </Stack>
              <Stack direction="column" spacing={2}>
                <Typography className="field-title">:</Typography>
                <Typography className="field-title">:</Typography>
              </Stack>
              <Stack direction="column" spacing={2}>
                <Typography className="body-cell">
                  {editData?.supplierId?.name}
                </Typography>
                <Typography className="body-cell">
                  {editData?.warehouseId?.warehouseName}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          {editData?.voidBy !== null ? (
            <Grid item xs={6}>
                <Typography className="field-title">ចំណាំ</Typography>
                <TextField
              className="text-field"
              fullWidth
              multiline
              rows={2}
              size="small"
              value={editData?.voidBy?.remark}
            />
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <TabContext value={value}>
              <Box sx={{ borderColor: "divider" }}>
                {editData?.status !== "Rejected" ? (
                  <TabList onChange={handleChange}>
                    <Tab label="សំណើរប្រើប្រាស់" value="1" />
                    <Tab label="ពិនិត្យអនុម័ត" value="2" />
                    <Tab label="ការបញ្ជាដឹក" value="3" />
                    <Tab label="ការទទួល" value="4" />
                  </TabList>
                ) : (
                  <TabList onChange={handleChange}>
                    <Tab label="សំណើរប្រើប្រាស់" value="1" />
                  </TabList>
                )}
              </Box>
              <TabPanel value="1">
                <ViewReqPurchase editData={editData} />
              </TabPanel>
              <TabPanel value="2">
                <CheckApprove editData={editData} />
              </TabPanel>
              <TabPanel value="3">
                <ViewPurchase editData={editData} />
              </TabPanel>
              <TabPanel value="4">
                <ViewRecieve editData={editData} />
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
